export function headerSubtitle(resultAmount, word) {
  const element = document.getElementById('results-subtitle')
  let text = ''
  if (resultAmount > 0) {
    if (word) text = `${resultAmount} resultados para “${word}”`
    else text = `${resultAmount} resultados para sua busca`
  }

  if (element) element.innerHTML = text
}
